export default __webpack_public_path__ + "static/media/gdsc_logo_text.322689f8.svg";